import { memo } from 'react'

import { SlideType } from '@/organisms/FansiWinSlider'

import Cover from './includes/Cover'
import Informations from './includes/Informations'

function ProductCard(props: ProductCardProps) {
  const { slide, layout = 'grid' } = props
  const { id, title, uri } = slide

  return (
    <div className="relative w-full h-full">
      <div className="relative flex flex-col min-h-full overflow-hidden rounded-2xl">
        <Cover
          src={uri}
          name={title}
          layout={layout}
          id={id}
          refetch={props.refetch}
        />
        <Informations title={title} />
      </div>
    </div>
  )
}

interface ProductCardProps {
  slide: SlideType
  layout?: 'flex' | 'grid'
  asFeatured?: boolean
  refetch?: () => void
}

export default memo(ProductCard)
